/* TIVVO: scroll-animaties en interactie voor de tivvo-* secties */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  if (!design && !reduce) document.documentElement.classList.add('tv-js');

  var REVEAL = [
    '.tv-intro__inner > *',
    '.tv-stages__head', '.tv-stages__media',
    '.tv-parts__head', '.tv-parts__part',
    '.made-tested__media', '.made-tested__heading', '.made-tested__text', '.made-tested__row',
    '.indep-test__heading', '.indep-test__card',
    '.tv-story__copy', '.tv-story__values-heading', '.tv-story__value',
    '.tv-social__head', '.tv-social__clip',
    '.tv-mat__head', '.tv-mat__item', '.tv-split__media', '.tv-split__copy'
  ].join(',');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  function initReveal(root) {
    var groups = new Map();
    root.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('tv-reveal')) return;
      el.classList.add('tv-reveal');
      var parent = el.parentElement;
      var n = groups.get(parent) || 0;
      groups.set(parent, n + 1);
      el.style.setProperty('--tv-delay', Math.min(n, 6) * 0.08 + 's');
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* Fasen-tijdlijn */
  var stageLists = [];
  function initStages(root) {
    root.querySelectorAll('.tv-stages__list').forEach(function (list) {
      if (stageLists.indexOf(list) === -1) stageLists.push(list);
    });
    updateStages();
  }
  function updateStages() {
    var mid = window.innerHeight * 0.55;
    stageLists.forEach(function (list) {
      if (!list.isConnected) return;
      list.querySelectorAll('.tv-stages__item').forEach(function (item) {
        var r = item.getBoundingClientRect();
        var dotY = r.top + 14;
        item.classList.toggle('is-active', dotY < mid);
        var p = (mid - dotY) / (r.height + 52);
        item.querySelector('.tv-stages__rail').style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { updateStages(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', updateStages, { passive: true });

  /* Onderdelen-tabel: kolom/rij oplichten */
  function initParts(root) {
    root.querySelectorAll('.tv-parts__grid').forEach(function (grid) {
      if (grid.dataset.tvInit) return;
      grid.dataset.tvInit = '1';
      var cols = parseInt(getComputedStyle(grid).getPropertyValue('--cols'), 10) || grid.querySelectorAll('.tv-parts__part').length;
      var kids = Array.prototype.slice.call(grid.children);
      kids.forEach(function (el, i) {
        el.dataset.col = i % (cols + 1);
        el.dataset.row = Math.floor(i / (cols + 1));
      });
      var locked = null;
      function show(col, row) {
        kids.forEach(function (el) {
          el.classList.toggle('is-col', col !== null && el.dataset.col === col && el.dataset.col !== '0');
          el.classList.toggle('is-row', row !== null && el.dataset.row === row && el.classList.contains('tv-parts__label'));
        });
      }
      kids.forEach(function (el) {
        el.addEventListener('mouseenter', function () { show(el.dataset.col, el.dataset.row); });
        if (el.classList.contains('tv-parts__part')) {
          el.addEventListener('click', function () {
            locked = locked === el.dataset.col ? null : el.dataset.col;
            show(locked, null);
          });
        }
      });
      grid.addEventListener('mouseleave', function () { show(locked, null); });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initStages(root);
    initParts(root);
  }

  /* Kleurbolletjes op productkaarten: foto + link wisselen */
  function pick(dot) {
    var card = dot.closest('.card-wrapper') || dot.closest('.card') || dot.closest('.product-card') || dot.closest('.tv-pcard');
    if (!card) return;
    var img = card.querySelector('.card__media img, .img-primary, .tv-pcard__img img');
    var lbl = card.querySelector('[data-swatch-label]');
    if (lbl) lbl.textContent = dot.title;
    var clip = card.querySelector('.image-clipper.has-hover-effect');
    if (clip) clip.classList.remove('has-hover-effect');
    if (img && dot.dataset.src) {
      img.src = dot.dataset.src;
      img.srcset = dot.dataset.srcset || '';
    }
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = dot.dataset.url; });
    dot.parentElement.querySelectorAll('.card-swatches__dot').forEach(function (d) { d.classList.toggle('is-active', d === dot); });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.card-swatches__dot');
    if (!dot) return;
    e.preventDefault();
    pick(dot);
  });
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest('.card-swatches__dot');
    if (dot && window.matchMedia('(hover: hover)').matches) pick(dot);
  });

  /* Materialen: chips volgen het onderdeel in beeld */
  function initChips() {
    if (!('IntersectionObserver' in window)) return;
    var header = document.querySelector('.section-header, sticky-header');
    if (header) document.documentElement.style.setProperty('--tv-header-h', header.offsetHeight + 'px');
    document.querySelectorAll('.tv-mat__chips').forEach(function (nav) {
      var chips = nav.querySelectorAll('[data-tv-chip]');
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          chips.forEach(function (c) { c.classList.toggle('is-active', c.dataset.tvChip === e.target.id); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      chips.forEach(function (c) { var t = document.getElementById(c.dataset.tvChip); if (t) obs.observe(t); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initChips); else initChips();

  /* Productfoto's per kleur: thumbnails worden na kleurwissel vervangen (product-info.js), dus klikken via delegatie */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[id^="GalleryThumbnails"] [data-target] button');
    if (!btn) return;
    var gallery = btn.closest('media-gallery');
    if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(btn.closest('[data-target]').dataset.target, false);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* In-winkelwagen-knop: vulling, rimpel en "Toegevoegd"-vinkje */
(function () {
  var nl = (document.documentElement.lang || '').toLowerCase().indexOf('nl') === 0;
  var doneText = nl ? 'Toegevoegd' : 'Added';
  function setup(btn) {
    if (!btn || btn.classList.contains('tv-atc')) return;
    btn.classList.add('tv-atc');
    var fill = document.createElement('span'); fill.className = 'tv-atc__fill'; fill.setAttribute('aria-hidden', 'true');
    var done = document.createElement('span'); done.className = 'tv-atc__done'; done.setAttribute('aria-hidden', 'true');
    done.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' + doneText;
    btn.appendChild(fill); btn.appendChild(done);
  }
  function setupAll() { document.querySelectorAll('.product-form__submit').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll); else setupAll();
  document.addEventListener('pointerover', function (e) { var b = e.target.closest && e.target.closest('.product-form__submit'); if (b) setup(b); });

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit.tv-atc');
    if (!btn || btn.disabled) return;
    var r = btn.getBoundingClientRect();
    var dot = document.createElement('span');
    dot.className = 'tv-atc__ripple';
    dot.style.left = (e.clientX - r.left) + 'px';
    dot.style.top = (e.clientY - r.top) + 'px';
    btn.appendChild(dot);
    setTimeout(function () { dot.remove(); }, 650);
  });

  function celebrate() {
    document.querySelectorAll('.product-form__submit.tv-atc').forEach(function (btn) {
      btn.classList.add('is-added');
      clearTimeout(btn._tvT);
      btn._tvT = setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
    });
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) { bubble.classList.remove('tv-cart-bump'); void bubble.offsetWidth; bubble.classList.add('tv-cart-bump'); }
  }
  var hooked = false;
  function hook() {
    if (hooked || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    hooked = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'product-form') celebrate(); });
  }
  hook();
  document.addEventListener('DOMContentLoaded', hook);
  window.addEventListener('load', hook);
})();
